// @flow
import * as React from 'react';
import { getRoute } from '../router';
import { UserCircle, Envelope, PlugsConnected, ArrowLeft, Tag, Waves } from '@phosphor-icons/react';
import { Group, Menu } from './menu';
import { keycloak, KeycloakRoles } from '@coverright/shared/keycloak';

export const SettingsMenu = () => {
  const isAgentManager = keycloak?.realmAccess?.roles?.includes(KeycloakRoles.ROLE_AGENT_MANAGER)

  return <Menu>
    <Group items={[{
      label: 'Back',
      to: getRoute('clients'),
      icon: <ArrowLeft size={18} color="#1c434f" />
    }]} />

    <Group title={'My Account'}
           items={[{
             label: 'My profile',
             to: getRoute('profile'),
             icon: <UserCircle  size={18} color="#1c434f" />
           }, {
             label: 'Integrations',
             to: getRoute('integrations'),
             icon: <PlugsConnected  size={18} color="#1c434f" />
           }, ]} />

    {isAgentManager && <Group title={'Workspace'} items={[{
      label: 'Email templates',
      to: getRoute('emailTemplates'),
      icon: <Envelope size={18} color="#1c434f" />
    }, {
      label: 'Tags',
      to: getRoute('tags'),
      icon: <Tag size={18} color="#1c434f" />
    }, {
      label: 'Plan coverage',
      to: getRoute('planCoverage'),
      icon: <Waves size={18} color="#1c434f" />
    }]} />}

  </Menu>
};
